<template>
  <div>
    <div class="list-group song-list">
      <sidebar-nav v-if="loggedIn" :urlPrefix="urlPrefix" />

      <div v-if="ownArtists.length > 0 && !isPlaylistPage">
        <div class="list-group-item header">Artists</div>
        <div
          v-for="(a, i) in ownArtists"
          :key="a.id"
          v-show="showAllArtists || i < 5"
          class="list-group-item indent-1"
        >
          <router-link :to="`/artists/${a.id}/latest`" class="flex-grow-1">{{ truncate(a.name, 20) }}</router-link>
        </div>
        <div v-if="ownArtists.length > 5 && !showAllArtists" class="list-group-item indent-1">
          <a href="#" @click.prevent="showAllArtists = true">Show {{ ownArtists.length - 5 }} more artists...</a>
        </div>
      </div>

      <div v-if="ownArtists.length === 1 && !isPlaylistPage">
        <sidebar-songs :songs="songs" :urlPrefix="urlPrefix" />
      </div>

      <sidebar-playlist-view :playlists="ownPlaylists" />

      <div v-if="sharedArtists.length > 0 || sharedPlaylists.length > 0">
        <div class="list-group-item header">Shared</div>
        <sidebar-link v-for="a in sharedArtists" :key="`sa-${a.id}`" :href="`/shared/artists/${a.id}/latest`" class="flex-grow-1 indent-1">
          <img src="/images/microphone.svg" class="me-1">{{ a.name }}
        </sidebar-link>
        <sidebar-link :href="`/shared/playlist/${pl.id}`" v-for="pl in sharedPlaylists" :key="`sp-${pl.id}`" class="flex-grow-1 indent-1">
          <svg-icon src="/images/music-note-list.svg" class="sidebar-icon"/>{{ pl.name }}
        </sidebar-link>
      </div>

      <div v-if="userRole === 'admin'">
        <div class="list-group-item header">Admin</div>
        <a href="/admin" class="list-group-item indent-1">Dashboard</a>
      </div>
      <div v-if="!loggedIn">
        <a href="/users/sign_up" class="list-group-item upload-button">Sign Up</a>
        <a href="/users/sign_in" class="list-group-item upload-button">Log In</a>
      </div>
      <sidebar-link v-else href="/mixes/new" class="upload-button">
        ↑ Upload a mix
      </sidebar-link>
    </div>
    <div class="flex-grow-1 filler"></div>
  </div>
</template>
<style>
.sidebar-icon svg {
  width: 1rem;
}
</style>
<script>
import SidebarNav from './sidebar_nav.vue'
import SidebarSongs from './sidebar_songs.vue'
import SidebarPlaylistView from './sidebar_playlist_view.vue'
import SidebarLink from './sidebar_link.vue'

export default {
  components: { SidebarLink, SidebarNav, SidebarSongs, SidebarPlaylistView },
  props: {
    userRole: { type: String, required: true },
    artists: { type: Array, default: () => [] },
    songs: { type: Array, default: () => [] },
    playlists: { type: Array, default: () => [] },
    urlPrefix: { type: String, default: '' },
  },
  data() {
    return { showAllArtists: false }
  },
  computed: {
    ownArtists() { return this.artists.filter(a => !a.is_shared) },
    sharedArtists() { return this.artists.filter(a => a.is_shared) },
    ownPlaylists() { return this.playlists.filter(p => !p.is_shared) },
    sharedPlaylists() { return this.playlists.filter(p => p.is_shared) },
    isPlaylistPage() {
      return /^\/playlists\/\d+/.test(this.$route?.path || window.location.pathname)
    },
    loggedIn() {
      return window.mmmGlobals?.logged_in || false
    },
  },
  methods: {
    truncate(str, length) {
      if (!str) return ''
      if (str.length <= length) return str
      return str.slice(0, length - 3) + '...'
    }
  }
}
</script>
